import React, { useState } from 'react';
import Select from 'react-select';
import { Table } from 'antd';

const ShippingDtlsTab = () => {
const [disableHawbIssuedBy, setDisableHawbIssuedBy] = useState(true);

// Placeholder options (replace these with actual data)
const joborderOptions = [];
const agentOptions = [];
const customerOptions = [];
const quotationOptions = [];
const columns = [
    { title: "Head", dataIndex: "SNo", key: "SNo" },
    { title: "Category", dataIndex: "Name", key: "Name" },
    { title: "Amount", dataIndex: "Alias", key: "Alias" },
    { title: "Tax Amount", dataIndex: "NVOCC", key: "NVOCC" },
];

const dataSource = [
    {
        key: "1",
    }
];

return (
<>
<form>
        <div className="card">
            <div className="card-body">
            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
            </div>
        </div>
    </form>
</>
)
}

export default ShippingDtlsTab